import { defineMessages } from "react-intl";

export const ErrorMessages = defineMessages({
    GenericError: {
        id: "ErrorMessage",
        defaultMessage: "An error has occurred. Please try again.",
    },
    MultipleDeviationsBeforeTask: {
        id: "MultipleDeviationsBeforeTask",
        defaultMessage: "Multiple deviations before a task on the following days: ",
    },
    MultipleDeviationsAfterTask: {
        id: "MultipleDeviationsAfterTask",
        defaultMessage: "Multiple deviations after a task on the following days: ",
    },
    Overlap: {
        id: "Overlap",
        defaultMessage: "An overlap of task start and end times on the following days: ",
    },
    BeforeOrAfterWhenNoTask: {
        id: "BeforeOrAfterWhenNoTask",
        defaultMessage: "Deviations on the following days without a task: ",
    },
    LongerAbsenceThanWork: {
        id: "LongerAbsenceThanWork",
        defaultMessage: "Deviations on the following days are longer than the task: ",
    },
} as const);
